import axios, {AxiosResponse} from 'axios';
import {AppConfig} from '@/app.config';
import {AuthStore} from "@/modules/Auth/stores/auth.store";

class HttpResource {
  httpAction({ params, action }: { params: any, action?: any }) {
    return (axios.post(AppConfig.apiUrl, {
      action: action,
      params,
      token: AuthStore.state.token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }

  customHttpAction(params: { url: string, data: any, withFormData?: boolean }) {
    if (params.withFormData) {
      const formData = new FormData();
      Object.keys(params.data).forEach(key => formData.append(key, params.data[key]));
      return (axios.post(params.url, formData) as Promise<AxiosResponse>);
    }
    else {
      return (axios.post(params.url, params.data) as Promise<AxiosResponse>);
    }
  }
}

export const httpResource = new HttpResource();
